import { useCurrentCustomerRegion, useCurrentMspRegion } from '@/services/region/useCurrentRegion';
import { useCallback } from 'react';

export const toMajor = (number: number) => {
  return number / 100;
};

export interface PrintCurrencyOptions {
  regionCode?: string;
  forceSpecifyRegion?: boolean;
}

export const usePrintCurrencyString = (options: PrintCurrencyOptions = {}) => {
  const { regionCode, forceSpecifyRegion } = options;

  return useCallback(
    (price?: number, overrideRegionCode?: string) => {
      if (price === undefined || Number.isNaN(price)) {
        return undefined;
      }

      return costToPrintedPrice(price, overrideRegionCode || regionCode, forceSpecifyRegion);
    },
    [regionCode, forceSpecifyRegion]
  );
};

const costToPrintedPrice = (cost: number, regionCode: string = 'GB', specifyRegion: boolean = false) => {
  let locale = 'en-GB';
  let currency = 'GBP';

  switch (regionCode) {
    case 'US':
      locale = 'en-US';
      currency = 'USD';
      break;
    case 'EU':
      locale = 'fr-FR';
      currency = 'EUR';
      break;
    case 'GB':
      locale = 'en-GB';
      currency = 'GBP';
      break;
    case 'AU':
      locale = 'en-AU';
      currency = 'AUD';
      break;
  }

  let price = toMajor(cost).toLocaleString(specifyRegion ? 'en-GB' : locale, { style: 'currency', currency });

  if (regionCode === 'AU') {
    price = price.replace('A$', 'AU$');
  }

  return price;
};

export const useCurrencyIdentifier = (regionCode = 'GB', simple = true) => {
  let shortDisplay = '£';
  let longDisplay = 'GBP £';

  switch (regionCode) {
    case 'US':
      shortDisplay = '$';
      longDisplay = 'USD $';
      break;
    case 'EU':
      shortDisplay = '€';
      longDisplay = 'EUR $';
      break;
    case 'GB':
      shortDisplay = '£';
      longDisplay = 'GBP £';
      break;
    case 'AU':
      shortDisplay = '$';
      longDisplay = 'AUD $';
      break;
  }

  if (simple) {
    return shortDisplay;
  } else {
    return longDisplay;
  }
};

export const usePrintCurrencyStringForCurrentMsp = () => {
  const selectedRegion = useCurrentMspRegion();

  return usePrintCurrencyString({ regionCode: selectedRegion?.code || 'GB' });
};

export const usePrintCurrencyStringForCurrentCustomer = () => {
  const selectedRegion = useCurrentCustomerRegion();

  return usePrintCurrencyString({ regionCode: selectedRegion?.code || 'GB' });
};
